<template>
  <div class="general-modal" v-if="state" @click="setToggleModal ? emitToggleModal() : ''">
    <div class="box-options" id="js-modal-general-structure" :class="modalSize"
         @mouseleave="setToggleModal = true" @mouseover="setToggleModal = false">
      <slot :name="card.slotName" v-for="(card, i) in settings[0].slot"></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: 'general-modal',
  props: {
    state:{
      type: Boolean,
      required: true
    },
    toggleModal: {
      type: Function,
      required: true
    },
    modalSize: {
      type: String,
      required: false
    },
    settings: {
      type: Array,
      default: function() {
        return [
          {
            'customModalWidth': '15vw',
            'customModalHeight': 'auto',
            'customModalPadding': '2rem',
            'slot': [
              {
                'slotName': 'header',
                'height': 'auto',
                'padding': '1rem'
              },
              {
                'slotName': 'body',
                'height': 'auto',
                'padding': '1rem'
              },
              {
                'slotName': 'bottom',
                'height': 'auto',
                'padding': '1rem'
              }
            ]
          }
        ]
      }
    }
  },
  data() {
    return {
      setToggleModal: true,
    }
  },
  mounted() {
    this.setStyle()
  },
  methods: {
    setStyle() {
      for (let i in this.settings[0].slot) {
        $( `#js-modal-general-${this.settings[0].slot[i].slotName}` ).css({
          'padding' : `${this.settings[0].slot[i].padding} !important`,
          'height' : `${this.settings[0].slot[i].height} !important`
        })
      }
      if (!isEmpty(this.settings[0].customModalWidth)
        && !isEmpty(this.settings[0].customModalHeight)
        && !isEmpty(this.settings[0].customModalPadding)
        && isEmpty(this.modalSize)) {
        $( '#js-modal-general-structure' ).css({
          'padding' : `${this.settings[0].customModalPadding}`,
          'width' : `${this.settings[0].customModalWidth}`,
          'height' : `${this.settings[0].customModalHeight}`
        })
      }
    },
    emitToggleModal() {
      this.toggleModal()
    }
  },
  watch: {
    settings: {
      handler: function() {
        this.setStyle()
      },
      deep: true
    },
  }
}
</script>
<style lang="scss" scoped>
.general-modal {
  width: 100%;
  height: 100%;
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
  z-index: 5000;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: auto;
  margin: 0;
  background: rgba(0,0,0,0.5);
  .box-options {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background-color: #fff;
    border-radius: 10px;
    padding: 2rem;
    &.xs {
      width: 15vw;
    }
    &.sm {
      width: 20vw;
    }
    &.md {
      width: 30vw;
    }
    &.lg {
      width: 40vw;
    }
    &.xl {
      width: 50vw;
    }
  }
}
@media only screen and (max-width: 1200px) {
  .box-options {
    width: 50% !important;
  }
}
@media only screen and (max-width: 1000px) {
  .box-options {
    width: 70% !important;
  }
}
@media only screen and (max-width: 800px) {
  .box-options {
    width: 90% !important;
  }
}

</style>



// WEBPACK FOOTER //
// resources/office/js/components/dashboard-v5/modal/GeneralModal.vue